export default __webpack_public_path__ + "static/media/logoMariseta.58373b13.svg";